export default "__VITE_ASSET__bAJJtuKo__"